import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
// React
import React from 'react';

// Constants
import DeviceBreakPoints from '../configurations/deviceBreakpoints';

// Libs
import i18n from '../i18n';

// MUI
import { Box, Typography } from '@mui/material';

//interfaces

var RegisterTab = function RegisterTab(props) {
  var _ref, _sortedForm$filter$;
  var _DeviceBreakPoints = DeviceBreakPoints(),
    isSmallDevice = _DeviceBreakPoints.isSmallDevice,
    theme = _DeviceBreakPoints.theme;
  var stepsArray = _toConsumableArray(props === null || props === void 0 ? void 0 : props.dynamicForm.steps);
  var sortedForm = (_ref = _toConsumableArray(stepsArray)) === null || _ref === void 0 ? void 0 : _ref.sort(function (firstItem, secondItem) {
    return firstItem.order - secondItem.order;
  });
  var activeTabName = i18n.t((_sortedForm$filter$ = sortedForm.filter(function (tab) {
    return tab.order === (props === null || props === void 0 ? void 0 : props.activeTab);
  })[0]) === null || _sortedForm$filter$ === void 0 ? void 0 : _sortedForm$filter$.name);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isSmallDevice && activeTabName ? /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: 'primary.main',
      color: 'primary.contrastText',
      height: '50px',
      width: '180px',
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '16px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, activeTabName)) : sortedForm.map(function (tab) {
    if (tab.name) {
      return /*#__PURE__*/React.createElement(Box, {
        key: tab.name,
        sx: {
          height: '50px',
          width: '180px',
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '16px',
          backgroundColor: props.activeTab === tab.order ? 'primary.main' : 'secondary.main',
          color: props.activeTab === tab.order ? 'primary.contrastText' : 'text.primary',
          border: "1px solid ".concat(theme.palette.primary.main)
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        role: "tab",
        variant: "subtitle1"
      }, i18n.t(tab.name)));
    }
    return null;
  }));
};
export default RegisterTab;